module.exports = __webpack_public_path__ + "img/Chen.0d8f4254.png";